module.exports = __webpack_public_path__ + "img/B-range.5c8ad26a.svg";